import {PlayerAPI} from 'bitmovin-player';
import {FC} from 'react';
import {PlayerContext} from '../../hooks/usePlayerContext';
import {PlayerStateProvider} from '../../hooks/usePlayerState';
import {TrackStateProvider} from '../../hooks/useTrackContext';
import {UiContainer} from '../uiContainer';
import * as Styles from './playerUi.styles';

export interface PlayerUIProps {
  player: PlayerAPI | undefined | null;
  accentColor?: string;
}

export const PlayerUI: FC<PlayerUIProps> = ({
  accentColor = '#ffffff',
  player,
}) => {
  if (!player) return null;

  return (
    <Styles.Container>
      <PlayerContext.Provider value={{accentColor, player}}>
        <PlayerStateProvider>
          <TrackStateProvider>
            <UiContainer />
          </TrackStateProvider>
        </PlayerStateProvider>
      </PlayerContext.Provider>
    </Styles.Container>
  );
};
